import styled from 'styled-components';

import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';

type AssistantCompactionMessageProps = {
  text: string;
};

export const AssistantCompactionMessage = ({ text }: AssistantCompactionMessageProps) => {
  return (
    <Stack orientation="horizontal" space={3} align="center">
      <SeparatorLine />
      <Text color="textHelper" font="regular12" text={text} />
      <SeparatorLine />
    </Stack>
  );
};

const SeparatorLine = styled.div({
  flex: 1,
  height: 1,
  background: theme.color.border10,
});
